import { render } from "./AppHeader.vue?vue&type=template&id=826e4f6e&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=826e4f6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-826e4f6e"]])

export default __exports__